import { useState, useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import { StyledMainInput, StyledInput, StyledPairInput } from './StyledInput';

export const MainInput = ({
  element = 'input',
  type = 'text',
  fn = null,
  regEx = null,
  placehold = '',
  validator = null,
  className = '',
  errors = [''],
  value = '',
  disabled = false,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!value.length) inputRef.current.classList.remove('correct');
  }, [value]);

  const handleInput = e => {
    let val = e.target.value;

    if (regEx) val = val.match(new RegExp(regEx, 'g'))?.join('') || '';
    if (val.length) e.target.classList.add('correct');
    else e.target.classList.remove('correct');
    let err;

    if (validator) {
      err = validator(val);
      if (!Number.isNaN(+err)) {
        e.target.classList.add('error');
        e.target.nextElementSibling.textContent = errors[err] || '';
      } else {
        e.target.classList.remove('error');
        e.target.nextElementSibling.textContent = '';
      }
    }
    fn && fn(val, errors[err]);
  };

  return (
    <StyledMainInput className={className} element={element}>
      <StyledInput
        as={element}
        type={type}
        onInput={handleInput}
        value={value}
        placeholder={placehold}
        ref={inputRef}
        disabled={disabled}
      />
      <div className="errors-container">error</div>
    </StyledMainInput>
  );
};

export const MainActiveInput = ({
  type = 'text',
  fn = null,
  regEx = null,
  placehold = '',
  validator = null,
  className = '',
  errors = [''],
}) => {
  const [value, setValue] = useState('');

  const handleInput = e => {
    let val = e.target.value;

    if (regEx) val = val.match(new RegExp(regEx, 'g'))?.join('') || '';
    if (val.length) e.target.classList.add('correct');
    else e.target.classList.remove('correct');
    let err;

    setValue(val);
    if (validator) {
      err = validator(val);
      if (!Number.isNaN(+err)) {
        e.target.classList.add('error');
        e.target.nextElementSibling.textContent = errors[err] || '';
      } else {
        e.target.classList.remove('error');
        e.target.nextElementSibling.textContent = '';
      }
    }
    fn && fn(val, errors[err]);
  };

  return (
    <StyledMainInput className={className}>
      <StyledInput
        type={type}
        onInput={handleInput}
        value={value}
        placeholder={placehold}
      />
      <div className="errors-container">error</div>
    </StyledMainInput>
  );
};

export const PairedInput = ({
  types = ['text'],
  placeholds = [''],
  fns = [null],
  regExes = [null],
  validators = [null],
  errors = [''],
  values = ['', ''],
}) => {
  return (
    <StyledPairInput>
      <MainInput
        type={types[0]}
        fn={fns[0]}
        placehold={placeholds[0]}
        regEx={regExes[0]}
        validator={validators[0]}
        errors={errors}
        className="input"
        value={values[0]}
      />
      <MainInput
        type={types[1] || types[0]}
        fn={fns[1] || fns[0]}
        placehold={placeholds[1] || placeholds[0]}
        regEx={regExes[1] || regExes[0]}
        validator={validators[1] || validators[0]}
        errors={errors}
        className="input"
        value={values[1]}
      />
    </StyledPairInput>
  );
};

MainInput.propTypes = {
  type: PropTypes.string,
  fn: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  regEx: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  placehold: PropTypes.string,
  validator: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  className: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
};
